(() => {
  'use strict';

  const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const SEASON_LABEL = { winter: 'A winter evening', spring: 'A spring evening', summer: 'A summer evening', fall: 'A fall evening' };
  // The menus. The tier cards in sections/cc-home.liquid show the same menus, so change both together.
  const TIERS = [
    { id: 'family', chip: 'Family Dinner', count: '4 courses', name: 'Family Dinner', price: 100,
      guide: 'Four courses around one table: bread, a soup, a main and dessert.',
      eg: ['The Secret Ingredient Bread and Butter', 'Butternut Squash Soup', 'Salmon and Quinoa', 'Pecan Pie, Vanilla Ice Cream'] },
    { id: 'five', chip: 'Five courses', count: '5 courses', name: 'Five Courses', price: 150,
      guide: 'Bread, a starter, a soup, a main and dessert.',
      eg: ['Bread and Butter', 'Roasted Pear with Feta and Local Honey', 'Wild Mushroom Soup', 'Engler Farms New York Strip, Potatoes Pavé', 'Banana Bread Pudding with Homemade Vanilla Ice Cream'] },
    { id: 'six', chip: 'Six courses', count: '6 courses', name: 'Six Courses', price: 200,
      guide: 'An amuse-bouche, a starter, a seasonal course, bread, a main and dessert.',
      eg: ['Pomme Soufflé, Chive and Crème Fraîche', 'Steak Carpaccio with Capers, Pickled Red Onions, Olive Oil, Salt', 'Seasonal Wild Mushroom', 'Bread with Seasonal Butter and Seasonal Spread', 'Choice of Beef or Fish with Seasonal Vegetables', 'Fudgy Brownie with Homemade Marshmallow and Banana Ice Cream'] },
    { id: 'eight', chip: 'Eight courses', count: '8 courses', name: 'Eight Courses', price: 250,
      guide: 'Eight courses designed with you, around your tastes, your story and your celebration.',
      eg: [],
      card: ['Eight courses, built around you', 'Your tastes, your story, your celebration', 'Custom designed in collaboration with you'] },
    { id: 'event', chip: 'An event', count: '', name: 'A Private Event', price: 0,
      guide: '', eg: [],
      card: ['A menu written with you', 'Sized to your guest list'] }
  ];

  const root = document.querySelector('.cc');
  if (!root) return;

  let reduce = false;
  try {
    reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch (e) {
    reduce = false;
  }
  root.setAttribute('data-js', '1');
  if (reduce) root.setAttribute('data-reduce', '1');

  // Scroll scenes, reveals, the drifting food rows and the nav tone.

  const nav = root.querySelector('.nav');
  const cardBox = root.querySelector('.ev-card');
  let raf = 0;

  const tick = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight || 800;
    const scrubs = root.querySelectorAll('[data-scrub]');
    const reveals = root.querySelectorAll('[data-reveal]:not([data-in])');
    const bgs = root.querySelectorAll('[data-bg]');
    const sr = Array.from(scrubs, (el) => el.getBoundingClientRect());
    const rr = Array.from(reveals, (el) => el.getBoundingClientRect());
    const br = Array.from(bgs, (el) => el.getBoundingClientRect());
    const rows = reduce ? [] : Array.from(root.querySelectorAll('.gal-row'));
    const rowR = rows.map((row) => ({
      r: row.getBoundingClientRect(),
      over: Math.max(0, row.scrollWidth - row.clientWidth),
      x: row.scrollLeft
    }));
    if (cardBox) {
      const h = cardBox.offsetHeight;
      if (cardBox.__ccH !== h) {
        cardBox.__ccH = h;
        cardBox.style.setProperty('--cardh', h + 'px');
      }
    }
    let yearP = reduce ? 1 : 0;
    if (!reduce) {
      scrubs.forEach((el, i) => {
        const r = sr[i];
        let p;
        if (el.getAttribute('data-scrub') === 'pin') {
          const run = r.height - vh;
          p = run > 0 ? -r.top / run : (r.top < 0 ? 1 : 0);
        } else {
          p = (vh - r.top) / (vh + r.height);
        }
        p = p < 0 ? 0 : (p > 1 ? 1 : p);
        if (el.id === 'year') yearP = p;
        const v = p.toFixed(4);
        if (el.__ccP !== v) {
          el.__ccP = v;
          el.style.setProperty('--p', v);
        }
      });
      reveals.forEach((el, i) => {
        if (rr[i].top < vh * 0.9) el.setAttribute('data-in', '1');
      });
      // Phones drift slower: the rows fill the screen there, so the desktop pace reads as a rush.
      const speed = (window.innerWidth || 1200) < 700 ? 0.35 : 0.72;
      const now = Date.now();
      rows.forEach((row, i) => {
        const o = rowR[i];
        const d = o.r.top + o.r.height / 2 - vh / 2;
        const dir = row.classList.contains('gal-b') ? -1 : 1;
        // Where the drift alone would put the row; a swipe or drag shifts that by __ccBase.
        const drift = o.over / 2 - dir * d * speed;
        if (row.__ccDrag || now < (row.__ccHand || 0)) {
          row.__ccBase = o.x - drift;
          return;
        }
        let x = drift + (row.__ccBase || 0);
        x = x < 0 ? 0 : (x > o.over ? o.over : x);
        if (Math.abs(o.x - x) >= 0.5) {
          row.scrollLeft = x;
          row.__ccOwn = row.scrollLeft;
        }
      });
    }
    if (nav) {
      const probe = 36;
      let tone = 'light';
      for (let i = 0; i < bgs.length; i++) {
        if (br[i].top <= probe && br[i].bottom > probe) {
          const bg = bgs[i].getAttribute('data-bg');
          if (bg === 'dark' || (bg === 'year' && yearP > 0.3)) tone = 'dark';
          break;
        }
      }
      if (nav.getAttribute('data-tone') !== tone) nav.setAttribute('data-tone', tone);
    }
  };

  const onScroll = () => {
    if (raf) return;
    raf = window.requestAnimationFrame(() => {
      raf = 0;
      tick();
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('load', onScroll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(onScroll);

  // The food rows also scroll by hand (swipe, trackpad, or drag with a mouse). The drift then
  // carries on from wherever the visitor left the row.
  Array.from(root.querySelectorAll('.gal-row')).forEach((row) => {
    const byHand = () => {
      row.__ccHand = Date.now() + 900;
      onScroll();
    };
    row.addEventListener('scroll', () => {
      if (row.__ccDrag || row.__ccOwn === undefined || Math.abs(row.scrollLeft - row.__ccOwn) > 1.5) byHand();
    }, { passive: true });
    row.addEventListener('dragstart', (e) => e.preventDefault());
    row.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      const x0 = e.clientX;
      const s0 = row.scrollLeft;
      row.__ccDrag = true;
      row.classList.add('is-drag');
      const move = (ev) => {
        row.scrollLeft = s0 - (ev.clientX - x0);
      };
      const up = () => {
        row.__ccDrag = false;
        row.classList.remove('is-drag');
        byHand();
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
        window.removeEventListener('pointercancel', up);
      };
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', up);
    });
  });

  tick();
  window.setTimeout(onScroll, 350);
  window.setTimeout(onScroll, 1400);

  // The enquiry tool: date, guests, name on the card, menu, the live menu card and the form.

  const calGrid = root.querySelector('.cal-grid');
  const form = root.querySelector('.send-form');
  if (!calGrid || !form) return;

  const pad = (n) => (n < 10 ? '0' : '') + n;
  const iso = (d) => d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  const fromIso = (s) => {
    const p = String(s).split('-');
    return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
  };
  const dateLabel = (d) => DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  const money = (n) => '$' + n.toLocaleString('en-US');

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const first = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
  const minKey = today.getFullYear() * 12 + today.getMonth();
  const maxKey = minKey + 12;
  const state = { vy: first.getFullYear(), vm: first.getMonth(), sel: iso(first), guests: 4, tier: 'family' };
  const currentTier = () => TIERS.find((t) => t.id === state.tier) || TIERS[0];

  const calTitle = root.querySelector('.cal-title');
  const calPrev = root.querySelector('[data-cal="prev"]');
  const calNext = root.querySelector('[data-cal="next"]');
  const guestsOut = root.querySelector('.st-val');
  const guestsDown = root.querySelector('[data-guests="down"]');
  const guestsUp = root.querySelector('[data-guests="up"]');
  const cardName = document.getElementById('cc-cardname');
  const chips = Array.from(root.querySelectorAll('.chip[data-tier]'));
  const magnet = document.getElementById('your-evening');
  const card = {
    season: root.querySelector('.mc-season'),
    menu: root.querySelector('.mc-menu'),
    forLine: root.querySelector('.mc-for'),
    date: root.querySelector('.mc-date'),
    table: root.querySelector('.mc-table'),
    badge: root.querySelector('.mc-ex span'),
    courses: root.querySelector('.mc-courses'),
    exNote: root.querySelector('.mc-exnote'),
    price: root.querySelector('.mc-price'),
    dep: root.querySelector('.mc-dep')
  };

  const markDate = () => {
    calGrid.querySelectorAll('.cal-d').forEach((b) => {
      const on = b.getAttribute('data-date') === state.sel;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  const renderCalendar = () => {
    const y = state.vy;
    const m = state.vm;
    const firstDow = new Date(y, m, 1).getDay();
    const dim = new Date(y, m + 1, 0).getDate();
    const cells = document.createDocumentFragment();
    for (let i = 0; i < firstDow; i++) {
      const blank = document.createElement('span');
      blank.className = 'cal-b';
      blank.setAttribute('aria-hidden', 'true');
      cells.appendChild(blank);
    }
    for (let d = 1; d <= dim; d++) {
      const dt = new Date(y, m, d);
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'cal-d';
      b.textContent = String(d);
      b.setAttribute('data-date', iso(dt));
      b.setAttribute('aria-label', DAYS[dt.getDay()] + ', ' + MONTHS[m] + ' ' + d);
      b.disabled = dt.getTime() <= today.getTime();
      cells.appendChild(b);
    }
    calGrid.replaceChildren(cells);
    calTitle.textContent = MONTHS[m] + ' ' + y;
    const key = y * 12 + m;
    calPrev.disabled = key <= minKey;
    calNext.disabled = key >= maxKey;
    markDate();
  };

  const renderGuests = () => {
    guestsOut.textContent = String(state.guests);
    guestsDown.disabled = state.guests <= 2;
    guestsUp.disabled = state.guests >= 40;
  };

  const renderChips = () => {
    chips.forEach((c) => {
      const on = c.getAttribute('data-tier') === state.tier;
      c.classList.toggle('on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  const renderCard = () => {
    const tier = currentTier();
    const sel = fromIso(state.sel);
    const sm = sel.getMonth();
    const season = (sm === 11 || sm <= 1) ? 'winter' : (sm <= 4 ? 'spring' : (sm <= 7 ? 'summer' : 'fall'));
    const name = cardName.value.trim();
    const priced = tier.price > 0;
    const total = state.guests * tier.price;
    const deposit = Math.round(total / 2);
    card.season.textContent = SEASON_LABEL[season];
    card.menu.textContent = tier.name;
    card.forLine.textContent = name ? 'Prepared for ' + name : 'Prepared for your table';
    card.date.textContent = dateLabel(sel);
    card.table.textContent = 'A table of ' + state.guests;
    card.badge.textContent = tier.eg.length > 0 ? 'Example menu' : 'Your menu';
    card.courses.replaceChildren(...(tier.card || tier.eg).map((course) => {
      const li = document.createElement('li');
      li.textContent = course;
      return li;
    }));
    card.exNote.hidden = tier.eg.length === 0;
    card.price.textContent = priced ? state.guests + ' guests × $' + tier.price + ' = ' + money(total) : 'Priced with Wade for your event';
    card.dep.textContent = priced ? money(deposit) + ' deposit (50%) holds the date' : 'A 50% deposit holds the date once your menu is set';
    onScroll();
  };

  const setTier = (id) => {
    state.tier = id;
    renderChips();
    renderCard();
  };

  const chooseTier = (id) => {
    setTier(id);
    if (!magnet) return;
    try {
      magnet.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    } catch (e) {
      magnet.scrollIntoView();
    }
  };

  const shiftMonth = (delta) => {
    const k = state.vy * 12 + state.vm + delta;
    if (k < minKey || k > maxKey) return;
    state.vy = Math.floor(k / 12);
    state.vm = k % 12;
    renderCalendar();
  };

  calGrid.addEventListener('click', (e) => {
    const b = e.target.closest('.cal-d');
    if (!b || b.disabled) return;
    state.sel = b.getAttribute('data-date');
    markDate();
    renderCard();
  });
  calPrev.addEventListener('click', () => shiftMonth(-1));
  calNext.addEventListener('click', () => shiftMonth(1));
  guestsDown.addEventListener('click', () => {
    state.guests = Math.max(2, state.guests - 1);
    renderGuests();
    renderCard();
  });
  guestsUp.addEventListener('click', () => {
    state.guests = Math.min(40, state.guests + 1);
    renderGuests();
    renderCard();
  });
  cardName.addEventListener('input', renderCard);
  chips.forEach((c) => c.addEventListener('click', () => setTier(c.getAttribute('data-tier'))));
  root.querySelectorAll('[data-choose]').forEach((b) => {
    b.addEventListener('click', () => chooseTier(b.getAttribute('data-choose')));
  });

  // The form is Shopify's contact form, so enquiries email Wade. Details are kept for this tab
  // so "Change something" and a returned error bring them back.
  const STORE = 'cc-evening';
  const loadedAt = Date.now();
  const saved = (() => {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORE) || 'null');
    } catch (e) {
      return null;
    }
  })();
  const remember = (data) => {
    try {
      window.sessionStorage.setItem(STORE, JSON.stringify(data));
    } catch (e) {
      // Storage can be off in private browsing; the enquiry still sends.
    }
  };

  if (saved) {
    const d = saved.sel ? fromIso(saved.sel) : null;
    if (d && d.getTime() > today.getTime() && d.getFullYear() * 12 + d.getMonth() <= maxKey) {
      state.sel = saved.sel;
      state.vy = d.getFullYear();
      state.vm = d.getMonth();
    }
    if (saved.guests >= 2 && saved.guests <= 40) state.guests = saved.guests;
    if (TIERS.some((t) => t.id === saved.tier)) state.tier = saved.tier;
    if (typeof saved.cardName === 'string') cardName.value = saved.cardName;
  }

  const sent = form.querySelector('.sent');
  if (sent) {
    const to = sent.querySelector('[data-sent-to]');
    if (to && saved && saved.email) to.textContent = ' to ' + saved.email;
    sent.querySelector('.sent-h').focus({ preventScroll: true });
  }

  const field = (key) => document.getElementById('cc-' + key);
  const submitBtn = form.querySelector('button[type="submit"]');
  if (submitBtn) {
    const REQUIRED = ['name', 'email', 'town'];
    const value = (key) => field(key).value.trim();

    if (saved) {
      ['name', 'email', 'town', 'phone', 'notes'].forEach((key) => {
        if (typeof saved[key] === 'string' && !field(key).value) field(key).value = saved[key];
      });
    }

    const setError = (key, msg) => {
      const note = document.getElementById('cc-' + key + '-err');
      if (msg) field(key).setAttribute('aria-invalid', 'true');
      else field(key).removeAttribute('aria-invalid');
      note.textContent = msg;
      note.hidden = !msg;
    };

    REQUIRED.forEach((key) => field(key).addEventListener('input', () => setError(key, '')));

    // Checked on the button press, before the form's submit event, so an invalid form never starts sending.
    submitBtn.addEventListener('click', (e) => {
      const trap = form.querySelector('input[name="contact[Website]"]');
      if (trap && trap.value) {
        e.preventDefault();
        return;
      }
      const email = value('email');
      const errors = {};
      if (!value('name')) errors.name = 'Please add your name.';
      if (!email) errors.email = 'Please add your email.';
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "That email doesn't look right.";
      if (!value('town')) errors.town = 'Which town is dinner in?';
      REQUIRED.forEach((key) => setError(key, errors[key] || ''));
      const bad = REQUIRED.find((key) => errors[key]);
      if (bad) {
        e.preventDefault();
        field(bad).focus();
        return;
      }

      const tier = currentTier();
      const priced = tier.price > 0;
      const total = state.guests * tier.price;
      const evening = dateLabel(fromIso(state.sel));
      const menu = tier.name + (priced ? ' ($' + tier.price + ' a guest)' : '');
      const estimate = priced
        ? state.guests + ' guests × $' + tier.price + ' = ' + money(total) + ', with a ' + money(Math.round(total / 2)) + ' deposit (50%)'
        : 'Priced with Wade';
      const name = cardName.value.trim();
      const notes = value('notes');
      const mirrors = { evening: evening, guests: String(state.guests), menu: menu, estimate: estimate, cardName: name };
      Object.keys(mirrors).forEach((key) => {
        const m = form.querySelector('[data-mirror="' + key + '"]');
        if (m) m.value = mirrors[key];
      });
      form.querySelector('[data-body]').value = [
        'Evening: ' + evening,
        'Guests: ' + state.guests,
        'Menu: ' + menu,
        'Estimate: ' + estimate,
        'Name on the card: ' + (name || 'Not given'),
        'Town: ' + value('town'),
        'Anything Wade should know: ' + (notes || 'Nothing added')
      ].join('\n');
      const check = form.querySelector('[data-check]');
      if (check) check.value = Date.now() - loadedAt < 5000 ? 'fast' : 'ok';
      remember({
        sel: state.sel,
        guests: state.guests,
        tier: state.tier,
        cardName: name,
        name: value('name'),
        email: email,
        town: value('town'),
        phone: value('phone'),
        notes: notes
      });
      submitBtn.textContent = 'Sending…';
    });
  }

  renderCalendar();
  renderGuests();
  renderChips();
  renderCard();
})();
